class Product extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerHeader = document.querySelector('.js-cart-drawer-header');
  }

  onVariantChange(event, target = null) {
    this.updateOptions();
    this.getVariantData();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.toggleAddButton(true, '');
    this.handleErrorMessage('');

    if (this.currentVariant && this.currentVariant != undefined) {
      this.updateVariantInput();
      this.renderProductInfo(event, target);
      this.updateMedia();

      if (this.currentVariant.available) this.toggleAddButton(false);
      else this.toggleAddButton(true, window.variantStrings.soldOut);
    } else this.toggleAddButton(true, window.variantStrings.unavailable);
  }

  updateButtonStyleBF() {
    const submitButton = this.querySelector('.js-submit-btn.pdp__button-main.pdp__addtocart');
    if (!submitButton) return;
    if (this.dataset.blackFriday == 'true' && this.currentVariant.compare_at_price > this.currentVariant.price){
      submitButton.classList.add('black-friday');
    } else {
      submitButton.classList.remove('black-friday');
    }
  }

  handleQtyInput() {
    const qtyControls = this.querySelector('.js-quantity-controls');
    if (!qtyControls) return;

    const qtyBtns = qtyControls.querySelectorAll('button');
    const inputQty = qtyControls.querySelector("input[type='number']");
    const currentValue = inputQty.value;

    qtyBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.target.name === 'plus' ? inputQty.stepUp() : inputQty.stepDown();
        if (currentValue !== inputQty.value)
          inputQty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  updateOptions() {
    this.options = [];

    for (let index = 1; index <= 3; index++) {
      const fieldsets = Array.from(
        this.querySelectorAll(
          `.js-fieldset[data-index='${index}'], .js-fieldset-swatch[data-index='${index}']`
        )
      );

      const selectedOption = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      });

      this.options.push(...selectedOption);
    }
  }

  getVariantData() {
    if (this.variantData) return this.variantData;
    else this.variantData = JSON.parse(this.querySelector('.js-product-variants').textContent);
  }

  updateMasterId() {
    this.currentVariant = this.variantData.find((variant) => {
      return (
        !variant.options || variant.options.every((option, index) => this.options[index] === option)
      );
    });
  }

  toggleAddButton(disable = true, text) {
    const productForm = this.querySelector(`#${this.dataset.id}`);

    if (!productForm) return;

    const addButton = productForm.querySelector('.js-submit-btn');
    const addButtonText = addButton.querySelector('.js-add-to-cart-message');

    if (!addButton && !addButtonText) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  updateVariantInput() {
    const productForm = this.querySelector(`#${this.dataset.id}`);
    if (!this.currentVariant || !productForm) return;

    const inputId = productForm.querySelector('input[name="id"]');
    if (inputId) inputId.value = this.currentVariant.id;
  }

  renderProductInfo(event, target = null) {
    this.updatePrice(target);
    this.updateSKU();
    this.updateButtonStyleBF();
  }

  updatePrice(target) {
    if (target === 'page'){
      const requestedVariantId = this.currentVariant.id;
      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
          this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
        }`
      ).then((response)=>response.text())
      .then((responseText)=>{
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.querySelector(`#shopify-section-${this.dataset.section} .pdp__price-wrapper`);
        const source = html.querySelector(`#shopify-section-${this.dataset.section} .pdp__price-wrapper`);
        if (source && destination){ 
          destination.innerHTML = source.innerHTML
          return;
        };

      })
    }
    
    const prices = this.querySelectorAll('.js-price');
    if (prices && this.currentVariant.price) {
      prices.forEach((price) => {
        price.innerHTML = localCurrency.formatPrice(this.currentVariant.price);
      });
    }

    const comparePrices = this.querySelectorAll('.js-compare-price');

    if (comparePrices) {
      comparePrices.forEach((comparePrice) => {
        if (
          this.currentVariant.compare_at_price === null ||
          this.currentVariant.compare_at_price <= this.currentVariant.price
        ) {
          comparePrice.classList.add('hidden');
        } else {
          comparePrice.classList.remove('hidden');
          if(comparePrice.classList.contains('black-friday')){
            let discountRate = Math.round((this.currentVariant.compare_at_price - this.currentVariant.price) / this.currentVariant.compare_at_price * 100);
            let svg = comparePrice.querySelector('svg');
            comparePrice.innerHTML = `%${discountRate} ${svg.outerHTML}`;
          } else {
            comparePrice.innerHTML = localCurrency.formatPrice(this.currentVariant.compare_at_price);
          }
        }
      });
    }
    const priceDifference = this.querySelectorAll('.js-price-difference');
    if(priceDifference){
      priceDifference.forEach((difference)=>{
        if (this.currentVariant.compare_at_price === null || this.currentVariant.compare_at_price <= this.currentVariant.price) {
          difference.parentElement.classList.add('hidden');
        } else {
          difference.parentElement.classList.remove('hidden');
          difference.innerHTML = localCurrency.formatPrice(this.currentVariant.compare_at_price - this.currentVariant.price);
        }
      })
    }
    const discountRate = this.querySelectorAll('.js-discount-rate');
    if(discountRate){
      discountRate.forEach((discount)=>{
        if (this.currentVariant.compare_at_price === null || this.currentVariant.compare_at_price <= this.currentVariant.price) {
          discount.parentElement.classList.add('hidden');
        } else {
          discount.parentElement.classList.remove('hidden');
          discount.innerHTML = Math.round((this.currentVariant.compare_at_price - this.currentVariant.price) / this.currentVariant.compare_at_price * 100);
        }
      })
    }
  }

  updateSKU() {
    const skuEls = this.querySelectorAll('.js-product-sku');

    if (skuEls && this.currentVariant?.sku) {
      skuEls.forEach((sku) => {
        sku.innerHTML = this.currentVariant.sku;
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked')?.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.js-fieldset, .js-fieldset-swatch')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('.js-product-option, .js-product-option-swatch')
      ];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked')?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value')))
        input.classList.remove('disabled');
      else input.classList.add('disabled');
    });
  }

  initForm() {
    const form = this.querySelector('.js-product-form'),
      addToCartBtn = this.querySelector('.js-submit-btn');

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.onSubmitHandler();
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', (event) => {
        this.onSubmitHandler();
      });
    }
  }

  async onSubmitHandler() {
    const submitButton = this.querySelector('.js-submit-btn');

    const formData = this.createFormData();
    if (!formData) return;

    if (submitButton.getAttribute('disabled') === 'disabled') {
      this.handleErrorMessage('');

      return;
    }

    submitButton.setAttribute('disabled', 'disabled');
    submitButton.classList.add('is-loading');

    await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          return;
        }

        publishEvent(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          data: response
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('is-loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawerHeader.classList.add('success');
      });
  }

  createFormData() {
    const form = this.querySelector('.js-product-form');

    let mainData = {
      items: [],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    };

    /** Add add-ons product */
    if (this.getAddOnProducts) {
      const addOnProducts = this.getAddOnProducts();
      if (addOnProducts && addOnProducts.length > 0) {
        mainData.items = [...mainData.items, ...addOnProducts];
      }
    }

    /** Add main product */
    if (form) {
      const formData = new FormData(form);

      mainData.items.push({
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1
      });
    }

    if (mainData.items.length > 0) return JSON.stringify(mainData);
    else return;
  }

  handleErrorMessage(errorMessageText = false) {
    const errorMessageWrapper = this.querySelector('.js-error-message-wrapper');
    if (!errorMessageWrapper) return;
    const errorMessage = errorMessageWrapper.querySelector('.js-error-message');

    if (errorMessageText) {
      errorMessageWrapper.classList.remove('hidden');
      errorMessage.textContent = errorMessageText;

      setTimeout(() => {
        errorMessageWrapper.classList.add('hidden');
      }, 5000);
    } else errorMessageWrapper.classList.add('hidden');
  }
}
